define.alias("shared/components/shared/post/copy/modal", "media/components/shared/post/copy/modal/index");